<template>
    <div class="container-fluid">
        <div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col col-xs-2">
                            <h4 class="panel-title">
                                <span class="title">Importação de Nota/Substituição.</span>
                                <br />
                                <span class="navigation">Importação de Nota/Substituição.</span>
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-10 mb-2">
                            <label for="file"><a
                                    href="https://s3.amazonaws.com/el.com.br/nfse/layout_aceites_substituicao.pdf"
                                    target="_blank">Clique aqui para baixar o Layout de importação</a></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10 mb-2">
                            <label for="file">Selecionar abaixo um arquivo, para realizar a importalçai: </label>
                            <br />
                            <span class="p-fluid">
                                <input type="file" id="files" ref="files" />
                            </span>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <span class="p-fluid mr-2">
                            <Button type="button" icon="pi pi-copy" label="Validar" title="Validar" />
                        </span>
                        <span class="p-fluid mr-2">
                            <Button type="button" icon="pi pi-check" label="Importar" title="Importar" class="p-button-primary mr-2 p-button-success"/>
                        </span>
                        <span class="p-fluid">
                            <router-link to="/declaracaoSubstituicao">
                                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                                    icon="pi pi-arrow-left"></Button>
                            </router-link>
                        </span>
                    </div>
                    <hr />

                </div>
            </div>
        </div>

    </div>
</template>
<script>


export default {
    name: "importacaoAceite",
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    }
};
</script>
  
<style scoped></style>